import React from 'react';
import Icon from '../../../components/AppIcon';


const LanguageTabs = ({ activeLanguage, onLanguageChange, completedLanguages = [] }) => {
  const languages = [
    { 
      code: 'ar', 
      label: 'العربية', 
      icon: 'Globe',
      direction: 'rtl',
      flag: '🇸🇾'
    },
    { 
      code: 'en', 
      label: 'English', 
      icon: 'Globe',
      direction: 'ltr',
      flag: '🇺🇸'
    },
    { 
      code: 'tr', 
      label: 'Türkçe', 
      icon: 'Globe',
      direction: 'ltr',
      flag: '🇹🇷'
    }
  ];

  const isLanguageCompleted = (langCode) => {
    return completedLanguages?.includes(langCode);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-1">
      <div className="flex space-x-1">
        {languages?.map((language) => {
          const isActive = activeLanguage === language?.code;
          const isCompleted = isLanguageCompleted(language?.code);
          
          return (
            <button
              key={language?.code}
              onClick={() => onLanguageChange(language?.code)}
              className={`
                relative flex items-center space-x-3 px-4 py-3 rounded-md text-sm font-medium transition-all duration-200
                ${isActive 
                  ? 'bg-primary text-primary-foreground shadow-sm' 
                  : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                }
              `}
            >
              {/* Flag */}
              <span className="text-lg">{language?.flag}</span>
              {/* Language Info */}
              <div className="flex items-center space-x-2">
                <span>{language?.label}</span>
                
                {/* Completion Indicator */}
                {isCompleted && (
                  <div className={`
                    w-2 h-2 rounded-full
                    ${isActive ? 'bg-primary-foreground' : 'bg-success'}
                  `} />
                )}
              </div>
              {/* Direction Indicator */}
              <Icon 
                name={language?.direction === 'rtl' ? 'AlignRight' : 'AlignLeft'} 
                size={14}
                className={isActive ? 'text-primary-foreground/70' : 'text-muted-foreground/70'}
              />
              {/* Active Indicator */}
              {isActive && (
                <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-primary-foreground rounded-full" />
              )}
            </button>
          );
        })}
      </div>
      {/* Language Progress */}
      <div className="mt-3 px-3">
        <div className="flex items-center justify-between text-xs text-muted-foreground mb-2">
          <span>اكتمال الترجمة</span>
          <span>{completedLanguages?.length}/3 لغات</span>
        </div>
        
        <div className="w-full bg-muted rounded-full h-1.5">
          <div 
            className="bg-success h-1.5 rounded-full transition-all duration-300"
            style={{ width: `${(completedLanguages?.length / 3) * 100}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default LanguageTabs;